/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type TradeOnboardingCoachmarkConditionalLoader_user$ref = any;
export type TradeOnboardingCoachmarkConditionalLoader_user = {
    readonly serviceId: string | null;
    readonly " $refType": TradeOnboardingCoachmarkConditionalLoader_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "TradeOnboardingCoachmarkConditionalLoader_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'f94bcabbf168345679c1f91512d4e4ae';
export default node;
